export const ENTERPRISE_VALUE = (equityValue: number, cash: number, debt: number): number =>
  equityValue - cash + debt;

export const EQUITY_VALUE = (enterpriseValue: number, cash: number, debt: number): number =>
  enterpriseValue + cash - debt;

export const getEnterpriseValueFormula = (enterpriseValue: string, cash: string, debt: string): string =>
  `ENTERPRISE_VALUE(${enterpriseValue}, ${cash}, ${debt})`;

export const getEquityValueFormula = (equityValue: string, cash: string, debt: string): string =>
  `EQUITY_VALUE(${equityValue}, ${cash}, ${debt})`;
